import calculArrondi from '@/services/general/calculArrondi';

export function calculNetBudget(budget) {
  if (budget.prixBrutNegocie === 0) {
    budget.prixNet = 0;
    return;
  }
  if (budget.remise.remise === 0) {
    budget.prixNet = budget.prixBrutNegocie;
    return;
  }
  if (!budget.prixBrutNegocie || !budget.remise.remise) return;
  budget.prixNet = calculArrondi(budget.prixBrutNegocie * (1 + budget.remise.remise / 100), 5);
}

export function calculRemiseBudget(budget) {
  if (budget.prixBrutNegocie === 0) {
    budget.remise.remise = 0;
    return;
  }
  if (budget.prixNet === 0) {
    budget.remise.remise = 100;
    return;
  }
  if (!budget.prixBrutNegocie || !budget.prixNet) return;
  budget.remise.remise = calculArrondi((budget.prixNet - budget.prixBrutNegocie) * 100 / budget.prixBrutNegocie, 5);
}
